import RequestCache from "./RequestCache";

export default class Insurance extends RequestCache {
    get cacheInterval() {
        return 7;
    }

    get link() {
        return this.links.insurance;
    }
}
